var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedactionRequestListEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 130,
    viewBox: "0 0 166 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_26347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5098 46.6602H53.1798",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7999 20.0792C16.4199 20.0792 17.7399 18.7592 17.7399 17.1392C17.7399 15.5192 16.4199 14.1992 14.7999 14.1992C13.1799 14.1992 11.8599 15.5192 11.8599 17.1392C11.8599 18.7592 13.1799 20.0792 14.7999 20.0792Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9102 20.0792C30.5302 20.0792 31.8502 18.7592 31.8502 17.1392C31.8502 15.5192 30.5302 14.1992 28.9102 14.1992C27.2902 14.1992 25.9702 15.5192 25.9702 17.1392C25.9702 18.7592 27.2902 20.0792 28.9102 20.0792Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94 20.0792C44.56 20.0792 45.88 18.7592 45.88 17.1392C45.88 15.5192 44.56 14.1992 42.94 14.1992C41.32 14.1992 40 15.5192 40 17.1392C40 18.7592 41.32 20.0792 42.94 20.0792Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.46 126.66C6.34 126.66 3 123.32 3 119.2V10.7998C3 6.67984 6.34 3.33984 10.46 3.33984H155.53C159.65 3.33984 162.99 6.67984 162.99 10.7998V117.51C162.99 117.51 163.28 126.65 154.2 126.65H29.24C24.69 126.65 21 122.96 21 118.41V33.9998H145V116.13",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23 106.44L120.4 110.61L129.85 101.16",
    stroke: "#4230E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3198 101.16L102.4 112.24",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 101.16L91.3198 112.24",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.95 58.0098H38.7998C35.8782 58.0098 33.5098 60.3782 33.5098 63.2998V80.1298C33.5098 83.0514 35.8782 85.4198 38.7998 85.4198H126.95C129.871 85.4198 132.24 83.0514 132.24 80.1298V63.2998C132.24 60.3782 129.871 58.0098 126.95 58.0098Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_26347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 128.32,
    fill: "white",
    transform: "translate(0.5 0.839844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedactionRequestListEmptyState);
export default __webpack_public_path__ + "static/media/redaction-request-list-empty-state.a61289766854873c610ffce7d5d9fb4b.svg";
export { ForwardRef as ReactComponent };